export { default } from './CompactBriefDesktop';
